import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetOwnerParams } from '../types/actionParams';

export class SetPublishedConnectionsOwnerRequest extends Request<ISetOwnerParams, IResult> {
  constructor(ids: string[], ownerId: string) {
    super('setPublishedConnectionsOwner', {
      ids: ids,
      ownerId: ownerId
    });
  }
}
